import axios from "axios";
import { logout } from "../lib/auth";

import { CONST } from "../config/const";
import { DataColumn } from "../config/dataInterface";

// ログイン時のカラム一覧取得
export async function getScreenColumns() {
  try {
    const path = "screenColumns";
    const response = await axios.get(CONST.apiUrl2 + path);
    const contractScreenColumn = response.data
      .contract_fetch_data as DataColumn[];
    const tossUpScreenColumn = response.data.toss_up_fetch_data as DataColumn[];
    const accountRunkingScreenColumn = response.data
      .account_runking_fetch_data as DataColumn[];
    return {
      contractScreenColumn,
      tossUpScreenColumn,
      accountRunkingScreenColumn,
    };
  } catch (error) {
    // logout();
    return {
      contractScreenColumn: [],
      tossUpScreenColumn: [],
      accountRunkingScreenColumn: [],
    };
  }
}

// 契約カラム一覧取得
export async function getScreenColumnContracts() {
  try {
    const path = "screenColumnContracts";
    const response = await axios.get(CONST.apiUrl2 + path);
    const fetch_data = response.data.fetch_data as {
      id: number;
      screen_column_auth: 0 | 1;
      screen_column_system_default: 0 | 1;
      table_disabled: 0 | 1;
      screen_column_serch_disabled: 0 | 1;
      detail_disabled: 0 | 1;
      screen_column_name: string;
      screen_column_type: 0 | 1 | 2;
      table_sort: 0 | 1;
      screen_column_table: 0 | 1;
      table_column_size: string;
      screen_column_sort_id: number;
      screen_column_serch: 0 | 1;
      screen_column_detail: 0 | 1;
    }[];
    return { fetch_data };
  } catch (error) {
    // logout();
    return { fetch_data: [] };
  }
}

// 契約カラム一更新
export async function putScreenColumnContracts(
  columns: {
    id: number;
    screen_column_auth: 0 | 1;
    screen_column_system_default: 0 | 1;
    table_disabled: 0 | 1;
    screen_column_serch_disabled: 0 | 1;
    detail_disabled: 0 | 1;
    screen_column_name: string;
    screen_column_type: 0 | 1 | 2;
    table_sort: 0 | 1;
    screen_column_table: 0 | 1;
    table_column_size: string;
    screen_column_sort_id: number;
    screen_column_serch: 0 | 1;
    screen_column_detail: 0 | 1;
  }[],
) {
  try {
    const path = "screenColumnContracts";
    const bodys = { columns };
    const response = await axios.put(CONST.apiUrl2 + path, {
      bodys,
    });
    return response.data.edit;
  } catch (error) {
    // logout();
  }
}

// ランキングカラム一覧取得
export async function getScreenColumnAccountRunkings() {
  try {
    const path = "screenColumnAccountRunkings";
    const response = await axios.get(CONST.apiUrl2 + path);
    const fetch_data = response.data.fetch_data as {
      id: number;
      screen_column_auth: 0 | 1;
      screen_column_system_default: 0 | 1;
      table_disabled: 0 | 1;
      screen_column_serch_disabled: 0 | 1;
      detail_disabled: 0 | 1;
      screen_column_name: string;
      screen_column_type: 0 | 1 | 2;
      table_sort: 0 | 1;
      screen_column_table: 0 | 1;
      table_column_size: string;
      screen_column_sort_id: number;
      screen_column_serch: 0 | 1;
      screen_column_detail: 0 | 1;
    }[];
    return { fetch_data };
  } catch (error) {
    // logout();
    return { fetch_data: [] };
  }
}

// ランキングカラム一更新
export async function putScreenColumnAccountRunkings(
  columns: {
    id: number;
    screen_column_auth: 0 | 1;
    screen_column_system_default: 0 | 1;
    table_disabled: 0 | 1;
    screen_column_serch_disabled: 0 | 1;
    detail_disabled: 0 | 1;
    screen_column_name: string;
    screen_column_type: 0 | 1 | 2;
    table_sort: 0 | 1;
    screen_column_table: 0 | 1;
    table_column_size: string;
    screen_column_sort_id: number;
    screen_column_serch: 0 | 1;
    screen_column_detail: 0 | 1;
  }[],
) {
  try {
    const path = "screenColumnAccountRunkings";
    const bodys = { columns };
    const response = await axios.put(CONST.apiUrl2 + path, {
      bodys,
    });
    return response.data.edit;
  } catch (error) {
    // logout();
  }
}

// トスアップカラム一覧取得
export async function getScreenColumnTossUps() {
  try {
    const path = "screenColumnTossUps";
    const response = await axios.get(CONST.apiUrl2 + path);
    const fetch_data = response.data.fetch_data as {
      id: number;
      screen_column_auth: 0 | 1;
      screen_column_system_default: 0 | 1;
      table_disabled: 0 | 1;
      screen_column_serch_disabled: 0 | 1;
      detail_disabled: 0 | 1;
      screen_column_name: string;
      screen_column_type: 0 | 1 | 2;
      table_sort: 0 | 1;
      screen_column_table: 0 | 1;
      table_column_size: string;
      screen_column_sort_id: number;
      screen_column_serch: 0 | 1;
      screen_column_detail: 0 | 1;
    }[];
    return { fetch_data };
  } catch (error) {
    // logout();
    return { fetch_data: [] };
  }
}

// トスアップカラム一更新
export async function putScreenColumnTossUps(
  columns: {
    id: number;
    screen_column_auth: 0 | 1;
    screen_column_system_default: 0 | 1;
    table_disabled: 0 | 1;
    screen_column_serch_disabled: 0 | 1;
    detail_disabled: 0 | 1;
    screen_column_name: string;
    screen_column_type: 0 | 1 | 2;
    table_sort: 0 | 1;
    screen_column_table: 0 | 1;
    table_column_size: string;
    screen_column_sort_id: number;
    screen_column_serch: 0 | 1;
    screen_column_detail: 0 | 1;
  }[],
) {
  try {
    const path = "screenColumnTossUps";
    const bodys = { columns };
    const response = await axios.put(CONST.apiUrl2 + path, {
      bodys,
    });
    return response.data.edit;
  } catch (error) {
    // logout();
  }
}
